"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_PLATFORM_POLICY = exports.SOCIAL_RESTRICTED_CLASSES = void 0;
exports.restrictedClassesFor = restrictedClassesFor;
exports.allowedSocialChannels = allowedSocialChannels;
/**
 * Social restriction policy (spec "Restriction policy"). Platform defaults ship in code;
 * merchants can only TIGHTEN (social-policy table). One function decides for the UI AND the worker.
 */
const social_1 = require("./social");
exports.SOCIAL_RESTRICTED_CLASSES = ['tobacco', 'cannabis', 'firearms', 'alcohol', 'age_restricted'];
const ALL = [...social_1.SOCIAL_CHANNELS];
exports.SOCIAL_PLATFORM_POLICY = {
    tobacco: { label: 'Tobacco & Vape', blocked: ALL, notes: {} },
    cannabis: { label: 'Cannabis & CBD', blocked: ALL, notes: {} },
    firearms: { label: 'Firearms', blocked: ALL, notes: {} },
    alcohol: { label: 'Beer, Wine & Spirits', blocked: [], notes: { facebook: '21+ audience', instagram: '21+ audience' } },
    age_restricted: { label: 'Age-restricted products', blocked: ALL, notes: {} },
};
const LICENSE_CLASS = {
    tobacco: 'tobacco', cannabis: 'cannabis', firearms: 'firearms', alcohol: 'alcohol',
};
/**
 * Restricted classes from data that already exists (no keyword guessing):
 * compliance-preset licenseType values + whether anything marks the product age-restricted.
 * Unknown licence types and age-restricted-without-a-class fail CLOSED to 'age_restricted'.
 */
function restrictedClassesFor(input) {
    const out = new Set();
    for (const raw of input.licenseTypes) {
        const v = typeof raw === 'string' ? raw.trim().toLowerCase() : '';
        if (!v)
            continue;
        out.add(LICENSE_CLASS[v] ?? 'age_restricted');
    }
    if (input.ageRestricted && out.size === 0)
        out.add('age_restricted');
    return exports.SOCIAL_RESTRICTED_CLASSES.filter((c) => out.has(c));
}
/**
 * Effective allowed channels = connected − platform-blocked for any class − merchant-blocked.
 * Merchant blocks can only add; they can never lift a platform block.
 */
function allowedSocialChannels(input) {
    const decisions = social_1.SOCIAL_CHANNELS.map((channel) => {
        const blockingClass = input.classes.find((c) => exports.SOCIAL_PLATFORM_POLICY[c].blocked.includes(channel));
        if (blockingClass) {
            return { channel, allowed: false, reasonCode: 'platform_policy', reason: `${exports.SOCIAL_PLATFORM_POLICY[blockingClass].label} isn't allowed` };
        }
        if (input.merchantBlocked.includes(channel)) {
            return { channel, allowed: false, reasonCode: 'merchant_policy', reason: 'Blocked by your rule for this category' };
        }
        if (!input.connected.includes(channel)) {
            return { channel, allowed: false, reasonCode: 'not_connected', reason: 'Not connected' };
        }
        const notes = input.classes.map((c) => exports.SOCIAL_PLATFORM_POLICY[c].notes[channel]).filter((n) => !!n);
        return notes.length ? { channel, allowed: true, notes } : { channel, allowed: true };
    });
    return { allowed: decisions.filter((d) => d.allowed).map((d) => d.channel), decisions };
}
//# sourceMappingURL=social-policy.js.map